import { render, staticRenderFns } from "./ajFormDetail.vue?vue&type=template&id=586e188a&scoped=true"
import script from "./ajFormDetail.vue?vue&type=script&lang=js"
export * from "./ajFormDetail.vue?vue&type=script&lang=js"
import style0 from "./ajFormDetail.vue?vue&type=style&index=0&id=586e188a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e188a",
  null
  
)

export default component.exports